// services/tickets.js
import axiosInstance from './axiosInstance';

const TICKETS_API_URL = '/tickets';

const ticketsService = {
  // Obter totais de tickets
  async getTotals(idempresa) {
    try {
      const response = await axiosInstance.get(`${TICKETS_API_URL}/totals.php?idempresa=${idempresa}`);
      return response.data !== 'NOK' ? response.data : {};
    } catch (error) {
      console.error('Erro ao obter totais de tickets:', error);
      throw error;
    }
  },

  // Obter lista de tickets
  async get(idempresa, where = null) {
    try {
      let url = `${TICKETS_API_URL}/get.php?idempresa=${idempresa}`;
      if (where) {
        url += `&where=${where}`;
      }
      
      const response = await axiosInstance.get(url);
      return response.data !== 'NOK' ? response.data : [];
    } catch (error) {
      console.error('Erro ao obter tickets:', error);
      throw error;
    }
  },

  // Obter ticket por ID
  async getById(idempresa, idticket) {
    try {
      const response = await axiosInstance.get(`${TICKETS_API_URL}/getById.php?idempresa=${idempresa}&idticket=${idticket}`);
      return response.data !== 'NOK' ? response.data : {};
    } catch (error) {
      console.error('Erro ao obter ticket por ID:', error);
      throw error;
    }
  },

  // Validar ticket
  async validate(ticketData) {
    try {
      const response = await axiosInstance.post(`${TICKETS_API_URL}/validate.php`, ticketData);
      return response.data;
    } catch (error) {
      console.error('Erro ao validar ticket:', error);
      throw error;
    }
  },

  // Obter auditoria de ticket
  async getAuditById(idempresa, idticket) {
    try {
      const response = await axiosInstance.get(`${TICKETS_API_URL}/audit/getById.php?idempresa=${idempresa}&idticket=${idticket}`);
      return response.data !== 'NOK' ? response.data : [];
    } catch (error) {
      console.error('Erro ao obter auditoria do ticket:', error);
      throw error;
    }
  },

  // Criar/atualizar ticket
  async set(ticketData) {
    try {
      const response = await axiosInstance.post(`${TICKETS_API_URL}/set.php`, ticketData);
      return response.data;
    } catch (error) {
      console.error('Erro ao criar ticket:', error);
      throw error;
    }
  },

  // Obter valores de tickets
  async getValues(idempresa) {
    try {
      const response = await axiosInstance.get(`${TICKETS_API_URL}/values/get.php?idempresa=${idempresa}`);
      return response.data !== 'NOK' ? response.data : [];
    } catch (error) {
      console.error('Erro ao obter valores de tickets:', error);
      throw error;
    }
  },

  // Definir valores de tickets
  async setValues(valuesData) {
    try {
      const response = await axiosInstance.post(`${TICKETS_API_URL}/values/set.php`, valuesData);
      return response.data;
    } catch (error) {
      console.error('Erro ao definir valores de tickets:', error);
      throw error;
    }
  },

  // Obter configurações de tickets
  async getConfig(idempresa) {
    try {
      const response = await axiosInstance.get(`${TICKETS_API_URL}/config/get.php?idempresa=${idempresa}`);
      return response.data !== 'NOK' ? response.data : [];
    } catch (error) {
      console.error('Erro ao obter configurações de tickets:', error);
      throw error;
    }
  },

  // Definir configurações de tickets
  async setConfig(configData) {
    try {
      const response = await axiosInstance.post(`${TICKETS_API_URL}/config/set.php`, configData);
      return response.data;
    } catch (error) {
      console.error('Erro ao definir configurações de tickets:', error);
      throw error;
    }
  },

  // Obter tipos de tickets
  async getTypes(idempresa) {
    try {
      const response = await axiosInstance.get(`${TICKETS_API_URL}/types/get.php?idempresa=${idempresa}`);
      return response.data !== 'NOK' ? response.data : [];
    } catch (error) {
      console.error('Erro ao obter tipos de tickets:', error);
      throw error;
    }
  }
};

export default ticketsService;
